class StickyAnnouncementBar extends HTMLElement {
  connectedCallback() {
    this.sectionEl = this.closest('.shopify-section');
    if (!this.sectionEl) return;

    this.sectionEl.classList.add('is-sticky');
    this.setHeight = this.setHeight.bind(this);
    this.setHeight();

    if (window.ResizeObserver) {
      this.ro = new ResizeObserver(this.setHeight);
      this.ro.observe(this.sectionEl);
    }
  }

  disconnectedCallback() {
    if (this.ro) this.ro.disconnect();
    if (this.sectionEl) {
      this.sectionEl.classList.remove('is-sticky');
      this.sectionEl.style.removeProperty('--announcement-bar-height');
    }
    document.body.style.removeProperty('--announcement-bar-height');
  }

  setHeight() {
    const value = `${Math.round(this.sectionEl.offsetHeight)}px`;
    this.sectionEl.style.setProperty('--announcement-bar-height', value);
    document.body.style.setProperty('--announcement-bar-height', value);
  }
}

if (!customElements.get('sticky-announcement-bar')) {
  customElements.define('sticky-announcement-bar', StickyAnnouncementBar);
}
